import React from "react";

export function Discover({ subscribeLink }: { subscribeLink: string }) {
	return (
		<section className="section--discover section--dark">
			<div className="container grid">
				<div className="typography grid__col-12 grid__col-md-6">
					<p className="section-title">
						Discover the power of
						<br /> ch-aviation news package
					</p>
					<p className="section-description">
						A true ally of industry professionals, ch-aviation helps
						you stay up-to-date on all B2B-relevant topics in
						aviation.
					</p>
					<div className="btn-group">
						<a href={subscribeLink} className="btn btn--primary">
							Choose your plan
						</a>
					</div>
				</div>
			</div>
		</section>
	);
}
